import { apiSlice } from './apiSlice';
import { CATEGORIES_URL } from '../constants';

export const categoryApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // ✅ Get all categories
    getCategories: builder.query({
      query: () => ({
        url: CATEGORIES_URL,
      }),
      providesTags: ['Category'],
      keepUnusedDataFor: 5,
    }),

    // ✅ Get category by ID
    getCategoryById: builder.query({
      query: (id) => ({
        url: `${CATEGORIES_URL}/${id}`,
      }),
      keepUnusedDataFor: 5,
    }),

    // ✅ Create category
    createCategory: builder.mutation({
      query: (data) => ({
        url: CATEGORIES_URL,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Category'],
    }),

    // ✅ Update category
    updateCategory: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `${CATEGORIES_URL}/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Category'],
    }),

    // ✅ Delete category
    deleteCategory: builder.mutation({
      query: (id) => ({
        url: `${CATEGORIES_URL}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Category'],
    }),

    // ✅ Get subcategories by category name
    getSubcategoriesByName: builder.query({
      query: (name) => ({
        url: `${CATEGORIES_URL}/${encodeURIComponent(name)}/subcategories`,
      }),
      keepUnusedDataFor: 5,
    }),
    getSubcategoriesByNameV2: builder.query({
  query: (name) => ({
    url: `${CATEGORIES_URL}/${encodeURIComponent(name)}/V2-subcategories`,
  }),
  keepUnusedDataFor: 5,
}),

  }),
});

export const {
  useGetCategoriesQuery,
  useGetCategoryByIdQuery,
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
  useGetSubcategoriesByNameQuery, 
  useGetSubcategoriesByNameV2Query,
} = categoryApiSlice;
